<template>
  <div class="card card-consultant-list">
    <div class="card-header">
      <div class="input-group search-form">
        <div class="input-group-prepend border-0 pl-2">
          <img :src="iconSearch" alt="Search.." width="20">
        </div>
        <input
          v-model="searchConsultants"
          type="search"
          placeholder="Search.."
          class="form-control search-input"
          @input="filterTable"
        />
      </div>

      <div class="dropdown user-branch mt-3">
        <button class="btn dropdown-toggle w-100" data-toggle="dropdown">
          {{ selectedBranchName || 'All Branches' }}
        </button>
        <div class="dropdown-menu w-100">
          <input v-model="searchBranch" type="text" class="form-control dropdown-search">
          <a class="dropdown-item" @click="selectFilter('')">All Branches</a>
          <a v-for="branch in filteredBranches" :key="branch.id" class="dropdown-item" @click="selectFilter(branch)">
            {{ branch.name }}
          </a>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div v-if="isLoading" class="loading-spinner text-center">
        <div class="spinner-border" role="status" />
        <small>Loading users..</small>
      </div>
      <table id="consultants" class="w-100" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { userList } from "../../services/api/commissions";

import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "../../../sass/commissions/consultant-list.scss";

export default {
  name: 'ConsultantList',
  props: {
    role: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isLoading: false,
      isLoadingBranches: false,
      iconSearch: '/images/icon-search.svg',
      userBranches: [],
      consultants: [],
      searchConsultants: '',
      searchBranch: '',
      selectedBranchName: '',
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      selectedUserId: null
    }
  },
  mounted() {
    this.fetchBranches();
  },
  computed: {
    filteredBranches() {
      return this.userBranches.filter(branch =>
        branch.name.toLowerCase().includes(this.searchBranch.toLowerCase())
      );
    }
  },
  methods: {
    initDataTable() {
      $(document).ready(() => {
        $.fn.DataTable.ext.pager.numbers_length = 4;

        this.consultantList = $('#consultants').DataTable({
          dom: '<"top">rt<"bottom d-flex justify-content-between align-items-center"lp>',
          lengthMenu: [5, 10],
          pageLength: 10,
          data: this.consultants,
          pagingType: 'simple_numbers',
          pagingControls: 'input',
          language: {
            lengthMenu: '_MENU_',
            paginate: {
              previous: '<',
              next: '>',
              first: '',
              last: ''
            }
          },
          columns: [
            {
              data: 'name',
              sortable: false,
              render: (data, type, row) => {
                return `
                  <div class="card card-user" data-user-id="${row.id}">
                      <div class="profile">
                        <img src="${row.image}" class="img-sm" alt="${data}" />
                        <span>${data}</span>
                      </div>
                      <i class="fa fa-chevron-right"></i>
                  </div>
                `;
              }
            }
          ]
        }).on('click', '.card-user', (event) => {
          const $currentCard = $(event.currentTarget);

          if (!$currentCard.hasClass('active')) {
            $('.card-user').removeClass('active');
            $currentCard.addClass('active');

            const userId = $currentCard.data('user-id');
            const selectedUser = this.consultants.find(user => user.id === userId);

            this.selectedUserId = userId;
            this.selectedUser(selectedUser);
          }
        }).on('draw.dt', () => {
          $('.card-user').removeClass('active');

          this.consultantList.rows().nodes().to$().each((index, element) => {
            if ($(element).find('.card-user').data('user-id') === this.selectedUserId) {
              $(element).find('.card-user').addClass('active');
            }
          });
        });

        this.$nextTick(() => {
          this.highlightSelectedUser();
        });
      });
    },
    fetchBranches() {
      this.isLoadingBranches = true;

      axios.get('branch/list')
        .then(response => {
          this.userBranches = response.data;
          this.isLoadingBranches = false;
          this.fetchConsultantList();
        })
        .catch(error => {
          console.error('Error fetching branches:', error);
          this.isLoadingBranches = false;
        });
    },
    async fetchConsultantList() {
      this.isLoading = true;

      try {
        const response = await userList(this.role);

        if (response.status === 200) {
          this.consultants = response.data.map(user => ({
            id: user.id,
            name: user.name,
            image: user.image,
            branch_id: user.branch_id,
            position: user.position
          }));

          this.isLoading = false;
          this.initDataTable();
        }
      } catch (error) {
        console.error('Error fetching consultant list:', error);

        this.consultants = [];
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    filterTable() {
      if (this.consultantList) {
        this.consultantList.search(this.searchConsultants).draw();
      }
    },
    filterByBranch() {
      if (this.selectedFilter) {
        const filteredConsultants = this.consultants.filter(user => user.branch_id === this.selectedFilter);
        this.consultantList.clear().rows.add(filteredConsultants).draw();
      } else {
        this.consultantList.clear().rows.add(this.consultants).draw();
      }
    },
    selectFilter(branch) {
      this.selectedFilter = branch.id;
      this.selectedBranchName = branch.name;
      this.filterByBranch();
    },
    selectedUser(user) {
      this.selectedUserId = user.id;
      this.$emit('selected', user.id, user.name, user.position, this.currentMonth, this.currentYear);

      // Update the URL hash
      window.location.hash = `${user.id}-${this.currentYear}-${this.currentMonth}`;
    },
    highlightSelectedUser() {
      const hash = window.location.hash.substring(1);
      const [userId] = hash.split('-');

      if (userId) {
        this.selectedUserId = userId;

        this.$nextTick(() => {
          if (this.selectedUserId) {
            $(`.card-user[data-user-id="${this.selectedUserId}"]`).addClass('active');
          }
        });
      }
    }
  }
}
</script>